import React from 'react';

import './App.css';
//import Scss
import "./assets/scss/themes.scss";

// routes
import Route from './Routes/Index';

// Only initialize fake backend in demo mode
if (process.env.REACT_APP_DEMO_MODE === 'true') {
  const fakeBackend = require('./helpers/AuthType/fakeBackend').default;
  fakeBackend();
}

function App() {
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
